import { TextField, styled } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";

const CustomInputLabel = styled('label')({
    '& .last-char': {
        color: 'red', // Son karakterin rengi
    },
})

const CustomMuiTelInput = ({ label, ...props }: any) => {
    const styledLabel = (
        <CustomInputLabel>
            {label.slice(0, -1)}
            <span className="last-char">{label.slice(-1)}</span>
        </CustomInputLabel>
    );

    return (
        <MuiTelInput
            {...props}
            label={styledLabel}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{ maxLength: 17 }}
        />
    );
};
export default CustomMuiTelInput
